var _circle, _circle2, _circle3, _path, _path2, _path3, _g, _path4, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 91.5,
    cy: 91.5,
    r: 91,
    fill: "white",
    stroke: "#F37B2F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 91.5,
    cy: 91.5,
    r: 78,
    fill: "white",
    stroke: "#F37B2F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 91.5,
    r: 65,
    fill: "white",
    stroke: "#F37B2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.6425 92.0939L76.4142 63.482C74.8446 59.4823 70.9862 56.8516 66.6895 56.8516C59.2298 56.8516 54.174 64.4447 57.051 71.3273L78.0042 121.454C79.8706 125.919 84.2364 128.826 89.0758 128.826H98.0305C102.966 128.826 107.398 125.804 109.201 121.21L114.137 108.632C115.196 105.933 115.068 102.912 113.784 100.312L109.668 91.9778C107.398 87.3794 100.781 87.5558 98.7584 92.2686C96.6401 97.2044 89.6046 97.0938 87.6425 92.0939Z",
    fill: "#F37B2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3281 56.8516H54.269C52.7147 56.8516 51.6613 58.4337 52.2608 59.8677L80.5267 127.489C80.8653 128.299 81.6572 128.826 82.535 128.826H104.728C105.623 128.826 106.427 128.278 106.754 127.444L115.448 105.29C115.672 104.72 115.645 104.081 115.374 103.531L105.988 84.5254C105.166 82.8597 102.769 82.9236 102.036 84.6308L95.078 100.844C94.3107 102.632 91.7623 102.592 91.0515 100.781L74.3544 58.2331C74.0273 57.3997 73.2234 56.8516 72.3281 56.8516Z",
    fill: "#F37B2F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9711_3908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 56,
    width: 64,
    height: 73
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3281 56.8516H54.269C52.7147 56.8516 51.6613 58.4337 52.2608 59.8677L80.5267 127.489C80.8653 128.299 81.6572 128.826 82.535 128.826H104.728C105.623 128.826 106.427 128.278 106.754 127.444L115.448 105.29C115.672 104.72 115.645 104.081 115.374 103.531L105.988 84.5254C105.166 82.8597 102.769 82.9236 102.036 84.6308L95.078 100.844C94.3107 102.632 91.7623 102.592 91.0515 100.781L74.3544 58.2331C74.0273 57.3997 73.2234 56.8516 72.3281 56.8516Z",
    fill: "#F37B2F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9711_3908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.854 59.9884L137.883 93.6037L115.694 147.632L80.657 134.268L112.854 59.9884Z",
    fill: "#355935"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.505 55C111.151 55 105.154 61.0006 105.154 68.3927C105.154 75.2339 110.385 80.9591 117.046 81.6983C117.205 84.6117 116.796 88.7686 114.571 91.3341C114.036 91.9284 114.108 92.8415 114.701 93.3779C114.975 93.6097 115.322 93.7257 115.654 93.7257C116.016 93.7257 116.377 93.5952 116.666 93.3198C116.781 93.2474 117.085 93.1459 117.258 93.0735C117.547 92.972 117.793 92.885 117.981 92.7836C123.789 89.8268 127.636 84.0609 129.934 79.0749C131.263 76.176 132 72.7844 132 69.5957C132 69.1609 131.986 68.726 131.957 68.2912C131.48 60.9571 125.455 55 118.505 55Z",
    fill: "#355935"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.568,
    cy: 67.9694,
    r: 6.62073,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLogo);
export default __webpack_public_path__ + "static/media/download-logo.9a4810f47599dbdef9e2073235095403.svg";
export { ForwardRef as ReactComponent };